import { MenuItem, PrimeIcons } from "primeng/api";
import { UserPermission } from "./permission.constants.enum";

export interface NavigationItem extends MenuItem {
    shortTitle? : string;
    items?: NavigationItem[];
    visibleTo? : UserPermission[];
    pageTitle?: string;
    helpIndex?: number;
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
    {
        label: 'Screen',
        items: [
            {
                label: 'New Screen',
                title: 'New Screen for Medical Necessity',
                icon: PrimeIcons.EXCLAMATION_TRIANGLE,
                routerLink: 'screening',
                visibleTo: [
                  UserPermission.MedNecScreen_User,
                  UserPermission.MedNecScreen_Admin,
                  UserPermission.MedNecScreen_ISAdmin,
                  UserPermission.MedNecScreen_Quorum_User,
                  UserPermission.MedNecScreen_Quorum_Admin,
                  UserPermission.MedNecScreen_Quorum_ISAdmin,
                  UserPermission.SCREENER,
                  UserPermission.ADMIN
                ],
                pageTitle: 'New Screen',
                helpIndex: 1
            },
            {
                label: 'Search for Screen',
                title: 'Search for Medical Necessity Screen',
                icon: PrimeIcons.USER,
                routerLink: 'search-for-screening',
                visibleTo: [
                  UserPermission.MedNecScreen_User,
                  UserPermission.MedNecScreen_Admin,
                  UserPermission.MedNecScreen_ISAdmin,
                  UserPermission.MedNecScreen_Quorum_User,
                  UserPermission.MedNecScreen_Quorum_Admin,
                  UserPermission.MedNecScreen_Quorum_ISAdmin,
                  UserPermission.SCREENER,
                  UserPermission.ADMIN
                ],
                pageTitle: 'Search for Screening',
                helpIndex: 2
            }
        ]
    },
    {
        label: 'Administration',
        shortTitle: 'Admin',
        visibleTo: [
          UserPermission.MedNecScreen_Admin,
          UserPermission.MedNecScreen_ISAdmin,
          UserPermission.MedNecScreen_Quorum_Admin,
          UserPermission.MedNecScreen_Quorum_ISAdmin,
          UserPermission.SCREENER,
          UserPermission.ADMIN
        ],
        items: [
            {
                label: 'Facility',
                title: 'Facility',
                icon: PrimeIcons.LIST,
                routerLink: 'administration/facility',
                visibleTo: [
                  UserPermission.MedNecScreen_Admin,
                  UserPermission.MedNecScreen_ISAdmin,
                  UserPermission.MedNecScreen_Quorum_Admin,
                  UserPermission.MedNecScreen_Quorum_ISAdmin,
                  UserPermission.SCREENER,
                  UserPermission.ADMIN
                ],
                pageTitle: 'Facility - Administration'
            },
            {
                label: 'CPT',
                title: 'CPT',
                icon: PrimeIcons.LIST,
                routerLink: 'administration/cpt',
                visibleTo: [
                  UserPermission.MedNecScreen_Admin,
                  UserPermission.MedNecScreen_ISAdmin,
                  UserPermission.MedNecScreen_Quorum_Admin,
                  UserPermission.MedNecScreen_Quorum_ISAdmin,
                  UserPermission.SCREENER,
                  UserPermission.ADMIN
                ],
                pageTitle: 'CPT - Administration'
            },
            {
                label: 'Diagnosis',
                title: 'Diagnosis',
                icon: PrimeIcons.LIST,
                routerLink: 'administration/diagnosis',
                visibleTo: [
                  UserPermission.MedNecScreen_Admin,
                  UserPermission.MedNecScreen_ISAdmin,
                  UserPermission.MedNecScreen_Quorum_Admin,
                  UserPermission.MedNecScreen_Quorum_ISAdmin,
                  UserPermission.SCREENER,
                  UserPermission.ADMIN
                ],
                pageTitle: 'Diagnosis - Administration'
            },
            {
                label: 'Medical Necessity',
                title: 'Medical Necessity File Management',
                icon: PrimeIcons.LIST,
                routerLink: 'administration/medical-necessity',
                visibleTo: [
                  UserPermission.MedNecScreen_Admin,
                  UserPermission.MedNecScreen_ISAdmin,
                  UserPermission.MedNecScreen_Quorum_Admin,
                  UserPermission.MedNecScreen_Quorum_ISAdmin,
                  UserPermission.SCREENER,
                  UserPermission.ADMIN
                ],
                pageTitle: 'Medical Necessity - Administration'
            },
            {
                label: 'ABN / NNC',
                title: 'ABN / NNC',
                icon: PrimeIcons.LIST,
                routerLink: 'administration/abn-nnc',
                visibleTo: [
                  UserPermission.MedNecScreen_Admin,
                  UserPermission.MedNecScreen_ISAdmin,
                  UserPermission.MedNecScreen_Quorum_Admin,
                  UserPermission.MedNecScreen_Quorum_ISAdmin,
                  UserPermission.SCREENER,
                  UserPermission.ADMIN
                ],
                pageTitle: 'ABN / NNC - Administration'
            },
            {
                label: 'Users',
                title: 'Manage Users',
                icon: PrimeIcons.USER_EDIT,
                routerLink: 'administration/users',
                visibleTo: [
                  UserPermission.MedNecScreen_Admin,
                  UserPermission.MedNecScreen_ISAdmin,
                  UserPermission.MedNecScreen_Quorum_Admin,
                  UserPermission.MedNecScreen_Quorum_ISAdmin,
                  UserPermission.SCREENER,
                  UserPermission.ADMIN
                ],
                pageTitle: 'Users - Administration'
            },
            {
                label: 'Online Help',
                title: 'Online Help',
                icon: PrimeIcons.QUESTION_CIRCLE,
                routerLink: 'administration/online-help',
                visibleTo: [
                  UserPermission.MedNecScreen_ISAdmin,
                  UserPermission.MedNecScreen_Quorum_ISAdmin,
                  UserPermission.SCREENER,
                  UserPermission.ADMIN
                ],
                pageTitle: 'Online Help - Administration'
            },
            {
                label: 'Downtime',
                title: 'Application Downtime',
                icon: PrimeIcons.EYE_SLASH,
                routerLink: 'administration/downtime',
                visibleTo: [
                  UserPermission.MedNecScreen_ISAdmin,
                  UserPermission.MedNecScreen_Quorum_ISAdmin,
                  UserPermission.SCREENER,
                  UserPermission.ADMIN
                ],
                pageTitle: 'Downtime - Administration'
            },
        ]
    }
];

export enum SidebarState {
    EXPAND = 'Expand',
    COLLAPSE = 'Collapse'
}

export const COLLAPSED = 'collapsed';
